<template>
  <div class="page-users" :style="{ height: pageHeight + 'px' }">
    <div class="left-box">
      <div class="auth-box">
        <div class="title-box">
          <div class="title">员工信息</div>
          <div class="line"></div>
        </div>
        <div class="name-box">
          <div class="name-label">姓名：</div>
          <el-input v-model="currName" v-if="isEditName" v-focus @blur="handleEditName"></el-input>
          <div class="edit-name" v-if="!isEditName">{{ currName }}</div>
          <img :src="editImg" @click="handleEdit" />
        </div>
        <div class="auth-list-box">
          <div class="name-label name-label-auth">权限：</div>
          <div class="auth-list">
            <div class="room-tag" v-for="(item, index) in auths" :key="'auth' + index">
              <div class="tag-text">{{ item.show }}</div>
              <img :src="delTag" @click="delAuth(item, index)" />
            </div>
          </div>
        </div>
      </div>
      <div class="auth-box">
        <div class="title-box">
          <div class="title">权限设置</div>
          <div class="line"></div>
        </div>
        <div class="select-box">
          <hm-select v-model="tower" :arrs="towers" placeholder="选择楼" @change="towerChange">
          </hm-select>
          <hm-select v-model="floor" :arrs="floors" placeholder="选择层" @change="floorChange">
          </hm-select>
          <hm-select v-model="room" :arrs="rooms" placeholder="选择房" @change="roomChange">
          </hm-select>
          <hm-button class="add-auth" @click="addAuth">添加</hm-button>
        </div>
      </div>
    </div>
    <div class="right-box">
      <div class="search-box">
        <div class="search-img"><img :src="searchImg" /></div>
        <el-input placeholder="搜索" v-model="searchContent" @input="nameSearch"></el-input>
      </div>
      <div class="people-title">管理员</div>
      <div class="manage-box" v-for="(item, index) in manageList" :key="'manage' + index">
        <img :src="manageImg" class="manage-img" />
        <div class="manage-name">{{ item.username }}</div>
      </div>
      <div class="people-title">工作人员</div>
      <div class="add-worker-box" v-if="isShowAddWorker">
        <img :src="workerImg" />
        <el-input v-model="addName" v-focus @blur="handleAddUser"></el-input>
      </div>
      <el-scrollbar style="height: 100%">
        <div class="worker-box">
          <div class="worker-list" v-for="(item, index) in workerList" :key="'worker' + index">
            <img :src="workerImg" />
            <div class="worker-name" @click="handleWorker(item)">
              {{ item.username }}
            </div>
            <img :src="delImg" @click="handleDel(item)" />
          </div>
        </div>
      </el-scrollbar>
      <div class="add-box">
        <i class="el-icon-plus" @click="handleAdd"></i>
      </div>
    </div>

    <div class="mask-box" v-show="isMask" ref="mask">
      <div class="del-info-box">
        <div class="tip-title-box">
          <img :src="warningImg" />
          <div class="tip-title">确认删除此员工吗？</div>
        </div>
        <div class="btn-box">
          <div class="mask-btn" @click="back()">取消</div>
          <div class="mask-btn" @click="delWorker">
            <img :src="warningDelImg" />
            <div class="mask-btn-text">删除</div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="添加用户" :visible.sync="userVisible" width="350px">
      <el-form :model="userForm" ref="userForm" label-width="65px" :rules="rules">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="userForm.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="userForm.password" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="userVisible = false">取 消</el-button>
        <el-button type="primary" @click="userConfirm('userForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addUser, queryUser, updateUser, delUser, addDevice } from "../../api/user";
import { getBuilding, getFloor, getRoom } from "../../api/device";

export default {
  name: "User",
  data() {
    return {
      pageHeight: 0,
      searchContent: "",
      searchImg: require("../../assets/images/system/search.svg"),
      manageImg: require("../../assets/images/system/manage.svg"),
      manageList: [],
      workerImg: require("../../assets/images/system/worker.svg"),
      delImg: require("../../assets/images/system/delPeople.svg"),
      workerList: [],
      warningImg: require("../../assets/images/system/warning.svg"),
      warningDelImg: require("../../assets/images/system/del.svg"),
      userList: [],

      editImg: require("../../assets/images/system/edit.svg"),
      currId: "",
      currName: "",
      currPwd: "",
      isEditName: false,
      auths: [],
      delTag: require("../../assets/images/system/delTag.svg"),

      tower: "",
      floor: "",
      room: "",
      towers: [],
      floors: [],
      rooms: [],
      allRooms: [],

      addName: "",

      isMask: false,

      isShowAddWorker: false,
      deleteId: "",
      userVisible: false,
      userForm: {},
      rules: {
        username: [{
          required: true, message: '用户名不能为空', trigger: 'blur'
        }, {
          validator: this.checkUsername, trigger: 'blur',
        }],
        password: [{
          required: true, message: '密码不能为空', trigger: 'blur'
        }, {
          validator: this.checkPassword, trigger: 'blur',
        }]
      }
    };
  },
  created() {
    this.initPageHeight();
    window.addEventListener("resize", this.initPageHeight, false);
  },
  mounted() {
    this.getUserList();
    this.getTowers();
    this.getFloors();
    this.getRooms();
  },
  computed: {},
  methods: {
    initPageHeight() {
      this.pageHeight = window.innerHeight - 80;
    },

    // 获取用户列表
    getUserList() {
      queryUser({
        page: 1,
        size: 9999,
        authType: 1
      }).then((res) => {
        console.log("获取用户列表", res);
        this.userList = res.data.records;
        if (res.data.records.length > 0) {
          let manages = [];
          let workers = [];

          res.data.records.forEach((item) => {
            if (item.roleId == 1) {
              manages.push(item);
            } else {
              workers.push(item);
            }
          });

          this.manageList = manages;
          this.workerList = workers;
        }
      });
    },

    handleAdd() {
      // this.isShowAddWorker = true;

      this.userVisible = true;
      this.userForm = {}
    },

    checkUsername(rule, value, callback) {
      let reg = /^(?=.*[A-Za-z])(?=.*[0-9])[a-z0-9A-Z]{10,}$/;

      if (!reg.test(value)) {
        callback(new Error('用户名为字母+数字组合且长度不小于10'))
      } else {
        callback()
      }
    },
    checkPassword(rule, value, callback) {
      let reg = /^(?=.*[A-Za-z])(?=.*[0-9])[a-z0-9A-Z]{10,}$/;

      if (!reg.test(value)) {
        callback(new Error('密码为字母+数字组合且长度不小于10'))
      } else {
        callback()
      }
    },

    userConfirm(userForm) {
      this.$refs[userForm].validate((valid) => {
        if (valid) {
          this.handleAddUser()
        } else {
          return false;
        }
      })
    },

    // 添加用户
    handleAddUser() {
      // if (this.addName == "") {
      //   this.$message("用户名不能为空");
      // } else {
      addUser({
        // username: this.addName,
        // password: 123456,
        username: this.userForm.username,
        password: this.userForm.password,
        sex: "男",
        roleId: "3",
        roomIds: "",
      }).then((res) => {
        this.addName = "";
        this.isShowAddWorker = false;
        this.getUserList();
        this.$message({
          type: "success",
          message: "添加用户成功",
        });
        this.userVisible = false
      });
      // }
    },

    // 删除用户
    delWorker() {
      delUser({
        id: this.deleteId,
      }).then((res) => {
        this.getUserList();
        this.back();
        this.$message({
          type: "success",
          message: "删除成功",
        });
      });
    },

    // 获取楼列表
    getTowers() {
      getBuilding({
        page: 1,
        size: 9999,
      }).then((res) => {
        let list = [];
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            let obj = {
              value: item.id,
              label: item.name,
            };
            list.push(obj);
          });
        }

        this.towers = list;
      });
    },

    // 选择楼
    towerChange(e) {
      this.floor = "";
      this.room = "";
      this.getFloors();
      this.getRooms();
    },

    // 获取层列表
    getFloors() {
      getFloor({
        page: 1,
        size: 9999,
        buildingId: this.tower,
      }).then((res) => {
        let list = [];
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            let obj = {
              value: item.id,
              label: item.name,
            };
            list.push(obj);
          });
        }

        this.floors = list;
      });
    },

    // 选择层
    floorChange(e) {
      this.room = "";
      this.getRooms();
    },

    // 获取房列表
    getRooms() {
      getRoom({
        page: 1,
        size: 9999,
        buildingId: this.tower,
        floorId: this.floor,
      }).then((res) => {
        this.allRooms = res.data.items;
        let list = [];
        if (res.data.items.length > 0) {
          res.data.items.forEach((item) => {
            let obj = {
              value: item.id,
              label: item.name,
            };
            list.push(obj);
          });
        }

        this.rooms = list;
      });
    },

    // 选择房
    roomChange(e) { },

    // 选择用户
    handleWorker(data) {
      this.currName = data.username;
      this.currId = data.id;
      this.currPwd = data.password;

      let currAuth = data.roomList;

      if (currAuth.length > 0) {
        let list = [];
        currAuth.forEach((item) => {
          this.allRooms.forEach((itm) => {
            if (item == itm.id) {
              let obj = {
                show: `${itm.buildingName}-${itm.floorName}-${itm.name}`,
                roomId: itm.id,
              };
              list.push(obj);
            }
          });
        });

        this.auths = list;
      }
    },

    handleEdit() {
      if (this.currName == "") {
        this.$message("请选择用户");
      } else {
        this.isEditName = true;
      }
    },

    handleEditName() {
      let reg = /^(?=.*[A-Za-z])(?=.*[0-9])[a-z0-9A-Z]{10,}$/;
      if (!reg.test(this.currName)) {
        this.$message('用户名为字母+数字组合且长度不小于10')
      } else if (this.currName == "") {
        this.$message("用户名不能为空");
      } else {
        this.isEditName = false;
        this.handleUpdateUser({
          id: this.currId,
          username: this.currName,
          password: this.currPwd
        });
      }
    },

    // 添加用户权限
    addAuth() {
      let idList = [];
      if (this.auths.length > 0) {
        this.auths.forEach((item) => {
          idList.push(item.roomId);
        });
      }

      // 判断当量或批量
      if (this.room == "") {
        if (this.floor == "") {
          this.$message("请选择层");
        } else {
          this.allRooms.forEach((item) => {
            if (idList.indexOf(item.id) == -1) {
              let obj = {
                show: `${item.buildingName}-${item.floorName}-${item.name}`,
                roomId: item.id,
              };
              this.auths.push(obj);
            }
          });
          this.addUserAuth();
        }
      } else {
        if (idList.indexOf(this.room) == -1) {
          this.allRooms.forEach((item) => {
            if (item.id == this.room) {
              let obj = {
                show: `${item.buildingName}-${item.floorName}-${item.name}`,
                roomId: item.id,
              };
              this.auths.push(obj);
            }
          });

          this.addUserAuth();
        } else {
          this.$message("该房间已存在");
        }
      }
    },

    addUserAuth() {
      if (this.auths.length > 0) {
        let list = [];
        this.auths.forEach((item) => {
          list.push(item.roomId);
        });

        this.updateDevice({
          id: this.currId,
          roomList: list
        });
      }
    },

    // 删除用户权限
    delAuth(data, index) {
      this.auths.splice(index, 1);

      if (this.auths.length > 0) {
        let list = [];
        this.auths.forEach((item) => {
          list.push(item.roomId);
        });

        this.updateDevice({
          id: this.currId,
          roomList: list
        });
      } else {
        this.updateDevice({
          id: this.currId,
          roomList: [],
        });
      }
    },

    // 添加设备
    updateDevice(data) {
      addDevice(data).then(res => {
        this.getUserList();
        this.$message({
          type: 'success',
          message: '更新用户权限成功'
        })
      })
    },

    // 更新用户
    handleUpdateUser(data) {
      updateUser(data)
        .then((res) => {
          this.getUserList();
          this.$message({
            type: "success",
            message: "更新用户信息成功",
          });
        })
        .catch((err) => {
          this.currId = "";
          this.currName = "";
          this.auths = [];
        });
    },

    // 删除用户
    handleDel(data) {
      this.deleteId = data.id;
      this.isMask = true;
    },

    // 用户搜索
    nameSearch() {
      if (this.userList.length > 0) {
        let manages = [];
        let workers = [];

        this.userList.forEach((item) => {
          if (item.roleId == 1) {
            if (this.searchContent == "") {
              manages.push(item);
            } else if (item.username.indexOf(this.searchContent) != -1) {
              manages.push(item);
            }
          } else {
            if (this.searchContent == "") {
              workers.push(item);
            } else if (item.username.indexOf(this.searchContent) != -1) {
              workers.push(item);
            }
          }
        });

        this.manageList = manages;
        this.workerList = workers;
      }
    },

    back() {
      this.deleteId = "";
      this.isMask = false;
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.initPageHeight, false);
  },
  watch: {},
};
</script>

<style scoped lang='less'>
.page-users {
  width: 100%;
  display: flex;
  padding: 27px 0 27px 27px;
  box-sizing: border-box;

  img {
    cursor: pointer;
  }

  .left-box {
    flex: 1;
    height: 100%;
    margin-right: 30px;
    display: flex;
    flex-direction: column;

    .auth-box {
      width: 100%;
      flex: 1;

      .title-box {
        height: 16px;
        display: flex;
        align-items: center;

        .title {
          height: 16px;
          line-height: 16px;
          margin-right: 22px;
        }

        .line {
          flex: 1;
          height: 1px;
          background: #a4b8cf;
        }
      }

      .name-box {
        display: flex;
        align-items: center;
        margin: 22.5px 0 0 86px;

        .edit-name {
          width: 200px;
          height: 40px;
          line-height: 40px;
        }
      }

      .auth-list-box {
        display: flex;
        margin: 22.5px 0 0 86px;

        .auth-list {
          display: flex;
          flex-wrap: wrap;

          .room-tag {
            height: 24px;
            display: flex;
            align-items: center;
            background: #a4b8cf;
            margin: 0 9px 7px 0;
            border-radius: 8px;
            font-size: 14px;
            padding: 0 10px;

            .tag-text {
              height: 24px;
              line-height: 24px;
              padding-right: 10px;
            }
          }
        }
      }

      .name-label {
        min-width: 50px;
      }

      .name-label-auth {
        line-height: 22px;
      }

      .select-box {
        display: flex;
        justify-content: center;
        margin-left: 86px;
        margin-top: 22.5px;

        .add-auth {
          width: 133px;
        }
      }
    }
  }

  .right-box {
    width: 306px;
    height: 100%;
    background: #fff;
    border-radius: 8px;
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .search-box {
      width: 276px;
      height: 40px;
      display: flex;
      align-items: center;
      background: #efefef;
      border-radius: 8px;

      .search-img {
        width: 22px;
        height: 22px;
        margin: 0 12px;
      }
    }

    .people-title {
      margin: 15px 0 18px;
    }

    .manage-box {
      width: 276px;
      height: 32px;
      align-items: center;
      display: flex;
      margin-bottom: 16px;

      .manage-img {
        width: 32px;
        height: 32px;
        margin-right: 15px;
      }

      .manage-name {
        height: 16px;
        line-height: 16px;
      }
    }

    .add-worker-box {
      width: 276px;
      height: 32px;
      display: flex;
      align-items: center;
      margin-bottom: 16px;
    }

    .worker-box {
      width: 276px;
      flex: 1;

      .worker-list {
        width: 276px;
        height: 32px;
        display: flex;
        align-items: center;
        margin-bottom: 16px;

        .worker-name {
          height: 16px;
          line-height: 16px;
          flex: 1;
          padding: 0 15px;
          cursor: pointer;
        }
      }
    }

    .add-box {
      display: flex;
      justify-content: flex-end;
    }
  }

  .mask-box {
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(33, 64, 132, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    backdrop-filter: blur(2px);

    .del-info-box {
      width: 316px;
      height: 205px;
      background: #fff;
      border-radius: 12px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    .tip-title-box {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .tip-title {
      margin-left: 10px;
    }

    .btn-box {
      height: 78px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      background: #ebf0fc;
    }

    .mask-btn {
      width: 111px;
      height: 40px;
      background: #1d63fd;
      color: #fff;
      border: none;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .mask-btn-text {
      height: 40px;
      line-height: 40px;
      margin-left: 15px;
    }
  }
}
</style>
<style>
.page-users .search-box .el-input__inner {
  border: none;
  background: none;
  padding: 0 12px 0 0;
}

.page-users .add-worker-box .el-input__inner {
  border: none;
  background: none;
  padding: 0 15px;
}

.page-users .auth-box .select-box .el-select {
  width: 200px;
  margin-right: 36px;
}

.page-users .auth-box .select-box .el-input__inner {
  border-color: #c9d5ef;
  border-radius: 8px;
}

.page-users .name-box .el-input__inner {
  background: none;
  border: none;
}

.page-users .name-box .el-input {
  width: auto;
}

.page-users .room-tag .el-tag__close {
  color: #fff;
}

.el-select-dropdown__wrap {
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/system/user.vue